import React, { memo, Suspense, useCallback, useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import bem from 'utils/bem';
import Text from 'components/Text';
import { Skeleton } from '@mui/material';
import Model from '../../../../model';
import './index.sass';
import { formatPrice } from 'utils/format';

const { block, el } = bem('amount-field');

const AmountField = ({ specialist, ...rest }) => {

    const { ticketOptionsData } = specialist;

    return (
        <Suspense fallback={ <AmountFieldSkeleton/> }>
            <AmountFieldSuspended resource={ ticketOptionsData } specialist={specialist} {...rest} />
        </Suspense>
    )
}

const AmountFieldSuspended = memo((props) => {

    const { resource, specialist, ticketOptions, ...rest } = props;

    useMemo(() => {
        resource.read();
    }, [ specialist ]);

    const { servicesSet } = specialist.data

    const ticketOptionsWithOne = [
        { id: 0, visit: 1, price: servicesSet[0].price },
        ...ticketOptions
    ].sort((to1, to2) => +to1.visit - +to2.visit)

    return (
        <div className={ block() }>
            { ticketOptionsWithOne.map(option => <TicketOption key={ option.visit } { ...rest } { ...option } />) }
        </div>
    )
})

export const AmountFieldSkeleton = () => {
    return (
        <div className={ block() }>
            <TicketOptionSkeleton/>
        </div>
    )
}

const TicketOption = observer(( props ) => {

    const { visit, id, price, setAmount, amount, setTicketType } = props;

    const onClick = (e) => {
        e.preventDefault();
        setAmount(visit);
        if (visit > 1) {
            setTicketType(id);
        }
    }

    //  const rubFormat = Intl.NumberFormat('ru-RU', { style: 'currency', currency: 'RUB', maximumSignificantDigits: 3 })

    return <div className={ el('option', { selected: visit === amount }) } onClick={ onClick }>
        <div className={ el('amount') }><Text>{ visit }</Text></div>
        <div className={ el('price') }><Text>{ formatPrice(price) }</Text></div>
    </div>
})

const TicketOptionSkeleton = () => {
    return <div className={ el('option') } style={ { minHeight: '65px' } }>
        <div className={ el('amount') }><Text serif><Skeleton width={ 25 }/></Text></div>
        <div className={ el('price') }><Text><Skeleton width={ 50 }/></Text></div>
    </div>
}

export default observer(AmountField);
